import { render, staticRenderFns } from "./ModalHousekeeping.vue?vue&type=template&id=24fdee88&"
import script from "./ModalHousekeeping.vue?vue&type=script&lang=js&"
export * from "./ModalHousekeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports